export const CONFIG_CAT_DEV_KEY = "ZzncCGhDAECP_7yx7zrFPw/wJvYiluDfEmI_fbV6Kksng";
export const CONFIG_CAT_PROD_KEY = "ZzncCGhDAECP_7yx7zrFPw/l0ektyFk4UuiiKTYXgWdhQ";